export default {
  setIsShown({ commit }, isShown) {
    commit('SET_IS_SHOWN', isShown);
  },
};
